export default __webpack_public_path__ + "static/media/1504.3c9c61f2.png";